// Blue-collar jobs with logo images
export const jobsData = [
    {
        index: 0,
        icon: "⚡",
        image: "/images/sourced/electrical.png",
        title: "Electrician",
        rate: "PHP 800-1500/m",
        type: "Fulltime",
        companyName: "Building Services Inc",
        location: "Makati, Metro Manila",
        vacancy: "5",
        hours: "40-50h/week",
        description: "Skilled electrician needed for residential and commercial projects. Responsibilities include installation, maintenance, and repair of electrical systems. Must have valid license and safety certifications.",
        workplace: "On-site",
        education: "Trade Certification",
        experience: "3+ years",
        skills: ["Wiring", "Circuit Installation", "Safety"]
    },
    {
        index: 1,
        icon: "🔧",
        image: "/images/sourced/plumming.png",
        title: "Plumbing",
        rate: "PHP 900-1800/m",
        type: "Fulltime",
        companyName: "Pro Plumbing Solutions",
        location: "Quezon City, Metro Manila",
        vacancy: "3",
        hours: "45h/week",
        description: "Licensed plumber required for new installations and repairs. Work on water systems, drainage, and gas lines. Must be experienced in both residential and commercial plumbing.",
        workplace: "On-site",
        education: "Plumbing License",
        experience: "5+ years",
        skills: ["Pipe Installation", "Troubleshooting", "Code Compliance"]
    },
    {
        index: 2,
        icon: "🪛",
        image: "/images/sourced/carpentry.png",
        title: "Carpentry",
        rate: "PHP 1000-1600/m",
        type: "Fulltime",
        companyName: "Quality Construction Co",
        location: "Cebu City, Cebu",
        vacancy: "4",
        hours: "50h/week",
        description: "Experienced carpenter for residential construction projects. Skilled in framing, finishing, and furniture building. Must have strong attention to detail and safety awareness.",
        workplace: "On-site",
        education: "Carpentry Trade",
        experience: "4+ years",
        skills: ["Framing", "Finishing", "Welding"]
    },
    {
        index: 3,
        icon: "🔥",
        image: "/images/sourced/smaw.png",
        title: "SMAW Welder",
        rate: "PHP 1200-2000/m",
        type: "Fulltime",
        companyName: "Industrial Fabrication LLC",
        location: "Davao City, Davao",
        vacancy: "2",
        hours: "48h/week",
        description: "SMAW (Shielded Metal Arc Welding) specialist for structural steel and metal fabrication. High precision required. Must have valid welding certifications and experience with heavy equipment.",
        workplace: "On-site",
        education: "AWS Certification",
        experience: "4+ years",
        skills: ["SMAW", "Blueprint Reading", "Metal Fabrication"]
    },
    {
        index: 4,
        icon: "⚙️",
        image: "/images/sourced/machine.png",
        title: "Mechanical Works",
        rate: "PHP 1100-1900/m",
        type: "Fulltime",
        companyName: "Advanced Mechanical Services",
        location: "Laguna, Calabarzon",
        vacancy: "3",
        hours: "45h/week",
        description: "Mechanical technician for HVAC systems and industrial machinery. Installation, maintenance, and repair work. Must understand complex mechanical systems and have troubleshooting skills.",
        workplace: "On-site",
        education: "Mechanical Trade",
        experience: "3+ years",
        skills: ["HVAC", "Machinery Repair", "Hydraulics"]
    }
];

export const teamData = [
    {
        id: 1,
        name: "John Doe",
        image: "/images/sourced/fl-1.png",
        skills: ["Electrician", "Certified", "10+ Years"]
    },
    {
        id: 2,
        name: "Jane Smith",
        image: "/images/sourced/fl-2.png",
        skills: ["Plumbing", "Licensed", "8+ Years"]
    },
    {
        id: 3,
        name: "Michael Johnson",
        image: "/images/sourced/fl-3.png",
        skills: ["Carpentry", "Master", "12+ Years"]
    },
    {
        id: 4,
        name: "Janet Johnson",
        image: "/images/sourced/fl-4.png",
        skills: ["SMAW Welding", "AWS Certified", "9+ Years"]
    }
];

export const featuresData = [
    {
        id: 1,
        icon: "/images/sourced/fe 1.png",
        title: "Skilled Professionals",
        description: "Find certified and experienced blue-collar workers for your projects."
    },
    {
        id: 2,
        icon: "/images/sourced/fe 2.png",
        title: "Quick Hiring",
        description: "Fast onboarding process with verified credentials and certifications."
    },
    {
        id: 3,
        icon: "/images/sourced/fe 3.png",
        title: "On-site Work",
        description: "Jobs with reliable on-site work across various industries."
    },
    {
        id: 4,
        icon: "/images/sourced/fe 4.png",
        title: "Competitive Pay",
        description: "Industry-competitive rates and benefits for skilled workers."
    }
];

export const trustedCompanies = [
    { id: 1, image: "/images/sourced/uc.png" },
    { id: 2, image: "/images/sourced/dole.png" },
    { id: 3, image: "/images/sourced/peso.png" },
    { id: 4, image: "/images/sourced/tesda.png" }
];
